export const PermissionFr = {
  "ACHATS": "ACHATS",
  "CATEGORIES": "CATEGORIES",
  "CLIENTS": "CLIENTS",
  "DEPENSES": "DEPENSES",
  "SERVICE": "SERVICE",
  "SERVICES": "SERVICES",
  "FOURNISSEURS": "FOURNISSEURS",
  "MODE_PAIEMENTS": "MODE PAIEMENTS",
  "PAIEMENTS": "PAIEMENTS",
  "PRODUITS": "PRODUITS",
  "ROLES": "ROLES",
  "STATISTIQUES": "STATISTIQUES",
  "UTILISATEURS": "UTILISATEURS",
  "VENTES": "VENTES",
  
  "AFFICHER": "AFFICHER",
  "AJOUTER": "AJOUTER",
  "MODIFIER": "MODIFIER",
  "SUPPRIMER": "SUPPRIMER",
  
  "AJOUTER_PAIEMENT": "AJOUTER PAIEMENT",
  "MODIFIER_PAIEMENT": "MODIFIER PAIEMENT",
  "SUPPRIMER_PAIEMENT": "SUPPRIMER PAIEMENT",
  "AFFICHER_LIST": "AFFICHER LIST",
  
}